import React, { Component } from "react";
import {
  matchUrl,
  createUrlLink,
  storyTemplates,
  checkUploadType,
  uploadPreview,
  wordFilter,
} from "../../utils/constants";
import { MentionsInput, Mention } from "react-mentions";
import defaultCreateStory from "../../pages/stories/defaultCreateStory";
import defaultMobileCreateStory from "../../pages/stories/defaultMobileCreateStory";
import defaultMentionStyle from "../../pages/stories/defaultMentionStyle";
import { Row, Col, Button, Label, ModalHeader, ModalBody } from "reactstrap";
import Toggle from "react-toggle";
import axios from "../../axios";
import * as url from "../../utils/url";
import classnames from "classnames";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { isMobile } from "../../utils/deviceInfo";
import If from "../Shared/If";
import { ReactTinyLink } from "react-tiny-link";
import * as actionCreators from "../../modules/actions/index";
// import ReactPlayer from 'react-player'
import ReactPlayer from "react-player/lazy";

import Loading from "../../hoc/Loading/Loading";

class StoryMentionsTxT extends Component {
  constructor(props) {
    super(props);
    this.state = {
      description: {
        value: this.props.description && this.props.description.value?this.props.description.value:  "",
      },
      title: "",
      rawText: "",
      isBadWords: "",
      // urlScrape: false,
      disableCreate: false,
      imageError: null,
      isVideo: false,
      setImagesPreview: [],
      rejectedFiles: [],
      mentionData: [],
      ogp: {
        urlScrape: false,
        requestUrl: "",
        // urlScrape:false,
        // ogImage:"",
        // ogDesc:"",
        // ogTitle:"",
        // ogType:"",
        // ogUrl:"",
        // ogSiteName:"",
        // extra:{}
      },
      newValue: "",
      image: "",
      isListFound: false,
      isListChecked: false,
      isListVisible: true,
      imageUrl: "",
      disableSubmit: true,
      privacy: true,
      isAnonymous: false,
      isAnonymousVisible: true,
      mentionsSelected: [],
      mentionsFound: [],
      mentionWord: "",
      topicAlert: false,
      isDescription: null,
      showReplies: false,
      topics: this.props.topics ? this.props.topics : [],
      topicsSelected: [{ name: "All" }],
      storyType: "",
      suggest: [],
      sentiment: null,
      storyLimit:
        this.props.storyLimit && this.props.storyLimit > 0
          ? this.props.storyLimit
          : 5000,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value != nextProps.value) {
      this.setState({
        description: { ...nextProps.value },
      });
    }
    if (
      JSON.stringify(this.props.mentionDataValue) !==
      JSON.stringify(nextProps.mentionDataValue)
    ) {
      this.setState({ mentionData: nextProps.mentionDataValue });
    }

    if (this.props.rawTextValue !== nextProps.rawTextValue) {
      this.setState({ rawText: nextProps.rawTextValue });
    }

    if (this.props.newTextValue !== nextProps.newTextValue) {
      this.setState({ newValue: nextProps.newTextValue });
    }

    if (
      JSON.stringify(this.props.ogpData) !== JSON.stringify(nextProps.ogpData)
    ) {
      this.setState({ ogp: nextProps.ogpData });
    }
  }

  scrapeUrlTxt = async text => {
    let urlString = matchUrl(text);
    let {ogp}=this.state
    let currentURL = ogp && ogp.ogUrl?ogp.ogUrl:'' 

    if (urlString && urlString.length > 0 && ( (urlString[0]!=currentURL) && (ogp && ogp.requestUrl != urlString[0]) ) ){
      await axios
        .get(url.getOpenGraphData, {
          params: {
            url: urlString[0],
          },
        })
        .then(({ data }) => {
          let { requestUrl } = data.data;
          if (data.data.data) {
            let resp = data.data.data;
            let { ogUrl } = resp;
            ogUrl = resp.ogUrl ? resp.ogUrl : requestUrl;
            let twitterAppNameGooglePlay = resp.twitterAppNameGooglePlay;
            let urlName = ogUrl ? ogUrl : requestUrl;
            let startNameURL = urlName.indexOf("w.") + 2;
            let endNameURL = urlName.indexOf(".com");
            let startEndDiff = endNameURL - startNameURL;
            let siteName = urlName.substr(startNameURL, startEndDiff);
            let ogSiteName = resp.ogSiteName
              ? resp.ogSiteName
              : twitterAppNameGooglePlay
              ? twitterAppNameGooglePlay
              : siteName;
            let ogImage =
              resp.ogImage && Array.isArray(resp.ogImage)
                ? resp.ogImage[0]
                : resp.ogImage;

            let res = {
              ogp: {
                ...resp,
                requestUrl: data.data.requestUrl,
                urlScrape: true,
                ogSiteName,
                ogUrl,
                ogImage,
              },
              isVideo:
                resp.ogType && resp.ogType.indexOf("video") > -1 ? true : false,
            };
            this.setState(res);
            this.props.canSubmit(res);
          }
        });
    }
    if(urlString==null || urlString==undefined){
      this.setState({ogp:{}})
    }
  };

  findUrl = siteUrl => {
    let httpIndex = siteUrl.indexOf("http");
    let httpString = siteUrl.substr(httpIndex);
    let afterHttp = httpString.indexOf(" ");
    let urlString = siteUrl.substr(httpIndex, afterHttp);
    // console.log(siteUrl, httpIndex, httpString, afterHttp, urlString)
    return urlString;
  };

  handleChangeStoryDescription = async (
    event,
    newValue,
    newPlainTextValue,
    mentions
  ) => {
    let { sanitizedDescription, storyLimit } = this.state,
      rawText = newPlainTextValue
    this.scrapeUrlTxt(newValue);
    // https://ideas.ted.com/emotionally-exhausted-burnout-completing-stress-response-cycle

    let storyLimitExtend = storyLimit

    const lastMention = mentions  ? mentions[mentions.length - 1]:null;

    console.log(lastMention,newValue)
    const isMentionAtEnd = lastMention && newValue.endsWith(lastMention.display+"}}");
  
    if (isMentionAtEnd) {
      // Temporarily increase the limit to accommodate the mention being typed
      const str = `@{{__user__||__${lastMention.id}__||__${lastMention.display}__}}`
      storyLimitExtend = storyLimit + (str.length * mentions.length);
   
    }



    let newStateObj = {
      rawText,
      newValue,
      description: { value: newValue },
      sanitizedDescription: {
        ...sanitizedDescription,
        value: rawText,
        storyMention: newValue,
      },
      disableSubmit: rawText.length == 0,
      error: 0,
    };

    if (mentions && mentions.length > 0) {
      newStateObj = {
        ...newStateObj,
        mentionData: { newValue, newPlainTextValue, mentions },
      };
    }

    if (rawText.length == 0) {
      newStateObj = {
        ...newStateObj,
        urlScrape: false,
        ogp: {},
        description: { value: "" },
      };
    } else if (rawText.length > storyLimit + 1) {
     
      newStateObj = {
        ...newStateObj,
        error: rawText.length > storyLimit + 1  ? 1: 0,
        description: { value: newValue.substr(0, storyLimitExtend) },
        disableSubmit: rawText.length == 0,
        // ogp:{
        // 	urlScrape,
        // 	...ogp
        // }
      };
    }
    // this.props.sendMentionsText(newStateObj)
    // console.log('newStateObj----', newStateObj)
    this.setState({ ...newStateObj });
    this.props.canSubmit(newStateObj);
  };

  removeOgp = () => {
    this.setState({
      ogp: {
        urlScrape: false,
      },
    });
  };

  fetchUsers = (query, callback) => {
    if (!query) return;
    let { isModule } = this.props;
    // console.log('query----', query)

    if (isModule && isModule == "GROUP") {
      let payload = {
        name: query,
        noLoader: true,
        group: this.props.groupObj,
      };
      axios
        .post(url.mentionUser, payload)
        .then((resp, idx) =>
          resp.data.data.map(user => ({
            id: user._id,
            display: `${user.firstName} ${user.lastName}`,
          }))
        )
        .then(callback);
    } else {
      axios
        .get(url.findUser(query))
        .then((resp, idx) =>
          resp.data.data.map(user => ({
            id: user._id,
            display: `${user.firstName} ${user.lastName}`,
          }))
        )
        .then(callback);
    }
  };

  returnSiteName = () => {
    let { ogp } = this.state;
    let { ogUrl, twitterAppNameGooglePlay, ogSiteName, requestUrl } = ogp;

    if (ogSiteName) {
      return ogSiteName;
    } else if (twitterAppNameGooglePlay) {
      return twitterAppNameGooglePlay;
    } else {
      let urlName = ogUrl ? ogUrl : requestUrl;
      let startNameURL = urlName.indexOf("w.") + 2;
      let endNameURL = urlName.indexOf(".com");
      let startEndDiff = endNameURL - startNameURL;
      let siteName = urlName.substr(startNameURL, startEndDiff);
      return siteName;
    }
  };
  // https://stackblitz.com/edit/react-mentions?file=index.js,tags.js

  render() {
    let {
      description,
      isVideo,
      ogp,
      rawText,
      storyLimit,
      newValue,
      sanitizedDescription,
      mentionData,
      mentionsText,
    } = this.state;
    let {
      urlScrape,
      ogImage,
      ogDesc,
      ogTitle,
      ogType,
      ogUrl,
      ogSiteName,
      twitterAppNameGooglePlay,
    } = ogp;

    let textValue;
    // console.log(this.state);
    // if (
    //   (sanitizedDescription &&
    //     sanitizedDescription.storyMention.indexOf("@") > -1) ||
    //   (description && description.value.indexOf("@") > -1)
    // ) {
    //   textValue =
    //     sanitizedDescription &&
    //     sanitizedDescription.storyMention &&
    //     sanitizedDescription.storyMention.length > 0
    //       ? sanitizedDescription.storyMention
    //       : mentionData &&
    //         mentionData.newValue &&
    //         mentionData.newValue.length > 0
    //       ? mentionData.newValue
    //       : newValue;
    // } else {
    //   textValue = description.value;
    // }
    textValue = description.value

    return (
      <span className="story-mention-container">
        <div className="input-wrapper createStoryInputContainer">
          <div className="createStoryInput">
            <span className="storyLengthText">
              {rawText && rawText.length}/{storyLimit}
            </span>

            {/* <span className="storyLengthText">{description&&description.value&&description.value.length}/5000</span> */}
            <MentionsInput
              autoFocus
              style={isMobile ? defaultMobileCreateStory : defaultCreateStory}
              value={textValue}
              onChange={this.handleChangeStoryDescription}
              markup="@{{__type__||__id__||__display__}}"
              placeholder={this.props.storyType}
              singleLine={false}
            >
              <Mention
                autoFocus
                type="user"
                trigger="@"
                style={defaultMentionStyle}
                data={this.fetchUsers}
                className="mentions__mention"
              />
            </MentionsInput>
          </div>

          {this.state.error == 1 ? (
            <span className="errorMsg">
              Too many characters. Only showing first {storyLimit} characters.
            </span>
          ) : null}
        </div>

        {urlScrape && isVideo != true ? (
          <div className="ogPreviewCreateContainer">
            {/* <div className= "removeOgpPreview" onClick={this.removeOgp}>
						X
						</div> */}
            <div className="ogPreviewContainer">
              <span
                className="removeOgpPreview flaticon-trash"
                onClick={this.removeOgp}
              />

             {ogImage && ogImage.url? <img src={ogImage.url} className="ogPreviewImage" />:null}
              <span className="ogPreviewContent">
                <span className="ogPreviewSite">
                  <a href={ogUrl} target="_blank">
                    {this.returnSiteName()}
                  </a>
                </span>
                <span className="ogPreviewTitle">{ogTitle}</span>
              </span>

              {/* <span>{ogDesc}</span> */}
              {/* , ogDesc, ogTitle, ogType, ogUrl, ogSiteName */}
            </div>
          </div>
        ) : null}

        {isVideo ? (
          <div className="ogPreviewCreateContainer">
            <span
              className="removeOgpPreview flaticon-trash"
              onClick={this.removeOgp}
            />
            {/* <div className= "removeOgpPreview" onClick={this.removeOgp}>
						X
						</div> */}
            <div className="isVideo ogPreviewContainer">
              <ReactPlayer
                className="ogPreviewImage"
                url={ogUrl}
                width="100%"
                height="100%"
              />
              <span className="ogPreviewContent">
                <span className="ogPreviewSite">
                  <a href={ogUrl} target="_blank">
                    {this.returnSiteName()}
                  </a>
                </span>
                <span className="ogPreviewTitle">{ogTitle}</span>
              </span>

              {/* <span>{ogDesc}</span> */}
              {/* , ogDesc, ogTitle, ogType, ogUrl, ogSiteName */}
            </div>
          </div>
        ) : null}
      </span>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.profile,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    storyMetricsChange: data =>
      dispatch(actionCreators.storyMetricsChange(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(StoryMentionsTxT, axios)));
